<template>
    <vx-chart-column
        tooltipItemKey="tooltip"
        :loading="loading"
        :error="error"
        @error="chartError = true"
        :data="chartData"
        :colors="data"
        :axis="{
            x: {
                key: 'label',
                axis: true,
                label: '',
                domain: data.map((item) => item.label),
                tickFormat: formatDateAxisTicks
            },
            y: {
                key: 'count',
                axis: true,
                label: '',
                ticks: 5,
                tickFormat: (v) => formatCount(v),
            },
        }"
    >
        <template v-slot:title>
            <slot name="title">
                <span>
                    Daily New Contacts
                </span>
            </slot>
        </template>
        <template v-slot:subtitle>
            <slot name="subtitle"></slot>
        </template>
        <template v-slot:right>
            <slot name="right">
                <experimental-pill subject="Beta Feedback - Analytics" v-if="!loading" class="-vx-mt-[4px]"></experimental-pill>
            </slot>
        </template>
        <template v-slot:footer>
            <vx-button
                href="/contacts"
                outline
                color="muted-light"
                size="xs"
            >
                Go to Contacts <font-awesome-icon :icon="faArrowRight" />
            </vx-button>
        </template>

        <template v-slot:explainHeader>Daily New Contacts</template>
        <template v-slot:explainContent>
            <p>
                Daily Gross Count of Contacts added into Voxie platform.
            </p>
            <p>
                <strong>New Contacts</strong><br />
                Gross Increase Count of Contacts during the selected period.
            </p>
        </template>
    </vx-chart-column>
</template>
<script setup>
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxChartColumn } from '@voxie/frontend-components';
import { ref, computed, watch } from 'vue';
import { formatCount } from '~/components/filters';
import ExperimentalPill from '../../../general/ExperimentalPill.vue';
import { useContactsTotalCreated } from '../states/useContactsTotalCreated'
import { formatDateAxisTicks } from '../../../../utils/analytics';

const props = defineProps({
    startDate: {
        type: String,
        required: true,
    },
    endDate: {
        type: String,
        required: true,
    },
});

const { data, loading, fetchData, error: fetchError } = useContactsTotalCreated();
const chartError = ref(false);
const chartData = computed(() => data.value.every((i) => i.count === 0) ? [] : data.value)

const error = computed(() => {
    return fetchError.value || chartError.value;
});

watch(
    [() => props.startDate, () => props.endDate],
    () => {
        chartError.value = false;
        fetchData({
            startDate: props.startDate,
            endDate: props.endDate,
        })
    },
    { immediate: true }
);
</script>
